import { render, staticRenderFns } from "./shoppingrecord.vue?vue&type=template&id=4dbbf095&scoped=true&"
import script from "./shoppingrecord.vue?vue&type=script&lang=js&"
export * from "./shoppingrecord.vue?vue&type=script&lang=js&"
import style0 from "./shoppingrecord.vue?vue&type=style&index=0&lang=css&"
import style1 from "./shoppingrecord.vue?vue&type=style&index=1&id=4dbbf095&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbbf095",
  null
  
)

export default component.exports